import { Box, Container, Typography } from '@mui/material'

const ErrorPage = (props) =>{
  return (
    <>
      <Container component='main' >
        <Box
          sx={{
            marginTop: 12,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb:2
          }}>
            <Typography variant={'h4'}>予期せぬエラーが起こりました。</Typography>
            <Typography variant={'body1'}><a href={window.location.href}>ここ</a>をクリックして最初から実行してください。</Typography>
            <Typography variant={'body2'}>繰り返し起こる場合はシステム管理者へご連絡ください </Typography>
          </Box>
      </Container>
    </>
  )
};

export default ErrorPage